<template>
  <div class="login">
    <div class="login-box">
      <div class="login-box-title">登录</div>
      <div class="login-box-item">
        <div class="label">
          用户名
        </div>
        <input type="text" v-model="name" maxlength="20">
      </div>
      <div class="login-box-item">
        <div class="label">
          邀请码
        </div>
        <input type="text" v-model="code" maxlength="20">
      </div>
      <div class="login-btn" @click="login">登录</div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      name:"",
      code:""
    }
  },
  methods:{
    login(){
      if(!this.name){
        alert('用户名不能为空')
        return
      }
      if(!this.code){
        alert('邀请码不能为空')
        return
      }
      if(this.code != '123456.qq'){
        alert('邀请码不正确')
        return
      }
      this.$router.push({path:'/test',query:{name:this.name}});
      // window.location.reload();
      // this.$router.push({name:'test',params:{name:this.name}});
    }
  }
}
</script>

<style scoped>
  .login{
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .login-box{
    box-shadow: 1px 5px 30px #cccccc;
    border-radius: 10px;
    padding: 20px;

  }
  .login-box-title{
    text-align: center;
    font-size: 25px;
    margin-bottom: 30px;
  }
  .login-box-item{
    display: flex;
    margin-bottom: 20px;
  }
  .label{
     font-size: 20px;
     margin-right: 10px;
     color: #333333;
  }
  input{
    padding:0 5px;
    height: 30px;
    outline: none;
    border: 1px solid #cccccc;
    border-radius: 5px;
  }
  .login-btn{
    cursor: pointer;
    display: inherit;
    width: 100%;
    height: 40px;
    background: #2FA7E0;
    color: #FFFFFF;
    border: 0;
    font-size: 15px;
    text-align: center;
    line-height: 40px;
    border-radius: 20px;
  }
  .login-btn:hover{
    opacity: 0.9;
  }
</style>



// WEBPACK FOOTER //
// src/components/login.vue